import { useCallback, useState } from "react"
import TagManager from "react-gtm-module"
import { isEmpty } from "../../../../utils/stringUtils"
import useActivationObject from "../../../providers/ActivationObjectProvider/hooks/useActivationObject"
import { useStep4Props, Step4Props } from "../types"
import useStep4Data from "./useStep4.data"

const useStep4 = (props: useStep4Props): Step4Props => {
    const { data: activationObject, update, isUpdating } = useActivationObject()
    const formProps = useStep4Data(activationObject)
    const [note, setNote] = useState<string>(activationObject?.note || "")
    const handleSetNote = useCallback((val: string) => setNote(val), [])

    const onSubmit = useCallback(() => {
        if (activationObject) {
            TagManager.dataLayer({
                dataLayer: {
                    event: "clickFinish",
                },
            })

            const newObject = {
                ...activationObject,
                wizardStep: "Finish",
                note: !isEmpty(note) ? note : null,
            }
            update(newObject)
        }
    }, [activationObject, note, update])

    return {
        ...props,
        dataProps: formProps,
        onSubmit,
        isUpdating,
        note,
        handleSetNote,
    }
}

export default useStep4
